const PocketTypes = {
    GAME: 'game',
    RESUME: 'resume',
    CONTACT: 'contact',
    FAITH: 'faith',
    SHOWCASE: 'showcase',
    TELEPORT: 'teleport' 
}

export default PocketTypes;